/**
 * @desc 导出VC合同信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.customsDeclarationMaster.exportVcCustomsClearanceContract.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/exportVcCustomsClearanceContract`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
